export default {
	resetLoading(ctx) {
		ctx.commit("SET_DATA_LOADING", true);
		ctx.commit("SET_DATA_LOADED", false);
	},
	dataLoaded(ctx) {
		ctx.commit("SET_DATA_LOADING", false);
		ctx.commit("SET_DATA_LOADED", true);
	},
	addToNotifications(ctx, payload) {
		console.log("payload", payload);
		console.log("state", ctx.state);

		let arr = ctx.state.notifications.concat(payload);

		console.log("array", arr);

		ctx.commit("SET_NOTIFICATIONS", arr);
		ctx.commit("SET_NOTIFICATIONS_STATE", true);
	},
	setNotifications(ctx, payload) {
		ctx.commit("SET_NOTIFICATIONS", payload);
		ctx.commit("SET_NOTIFICATIONS_STATE", true);
	},
	setNotificationsState(ctx, payload) {
		ctx.commit("SET_NOTIFICATIONS_STATE", payload);
	},
	setShowWelcomePopup(ctx, payload) {
		ctx.commit("SET_SHOW_WELCOME_POPUP", payload);
	},
	setLoggedOut(ctx) {
		ctx.commit("SET_LOGGED_OUT", true);
		localStorage.setItem("hasLoadedPermissions", JSON.stringify(false));
		ctx.commit("REMOVE_LOGOUT_TIME");
	},
	setMainSidebarOpenState(ctx, payload) {
		ctx.commit("SET_MAIN_SIDEBAR_OPEN_STATE", payload);
	},
	setSecondSidebarOpenState(ctx, payload) {
		ctx.commit("SET_ACCOUNT_SIDEBAR_OPEN_STATE", payload);
	},
	setAccountSubmenuOpenState(ctx, payload) {
		ctx.commit("SET_ACCOUNT_SUBMENU_OPEN_STATE", payload);
	},
	setEventSubmenuOpenState(ctx, payload) {
		ctx.commit("SET_EVENT_SUBMENU_OPEN_STATE", payload);
	},
	setMerchandiseSubmenuOpenState(ctx, payload) {
		ctx.commit("SET_MERCHANDISE_SUBMENU_OPEN_STATE", payload);
	},
	setLogoutTime(ctx, payload) {
		ctx.commit("SET_SESSION_EXPIRATION", payload);
	},
	resetSearchTerm(ctx) {
		ctx.commit("SET_SEARCH_TERM", '');
	}
};
